export enum FooterUnsubLanguagesEnum {
    english = 'English',
    danish = 'Danish',
    dutch = 'Dutch',
    finnish = 'Finnish',
    french = 'French',
    german = 'German',
    italian = 'Italian',
    norwegian = 'Norwegian',
    portuguese = 'Portuguese',
    spanish = 'Spanish',
    swedish = 'Swedish'
};

export const footerUnsubLanguagesToUnsubString: Map<FooterUnsubLanguagesEnum, string> = new Map([
    [FooterUnsubLanguagesEnum.english , 'unsubscribe'],
    [FooterUnsubLanguagesEnum.danish , 'afmeldelse'],
    [FooterUnsubLanguagesEnum.dutch , 'afmelden'],
    [FooterUnsubLanguagesEnum.finnish , 'lopeta tilaus'],
    [FooterUnsubLanguagesEnum.french , 'Se désabonner'],
    [FooterUnsubLanguagesEnum.german , 'abmelden'],
    [FooterUnsubLanguagesEnum.italian , 'disdire l\'abbonamento'],
    [FooterUnsubLanguagesEnum.norwegian , 'avmelding'],
    [FooterUnsubLanguagesEnum.portuguese , 'cancelar a assinatura'],
    [FooterUnsubLanguagesEnum.spanish , 'darse de baja'],
    [FooterUnsubLanguagesEnum.swedish , 'avanmäler dig'],
]);
